import { __rest, __assign } from 'tslib';
import React__default from 'react';
import { Box } from '../box/Box.js';
import { FlexGridContext } from './FlexGridContext.js';

var FlexGrid = function (_a) {
  var _b = _a.gutter,
    gutter = _b === void 0 ? 0 : _b,
    children = _a.children,
    rest = __rest(_a, ["gutter", "children"]);
  return React__default.createElement(FlexGridContext.Provider, {
    value: {
      gutter: gutter
    }
  }, React__default.createElement(Box, __assign({
    mx: "auto",
    overflow: "hidden"
  }, rest), children));
};

export { FlexGrid };
//# sourceMappingURL=FlexGrid.js.map
